import React from 'react';

const TrustBar = () => {
  return (
    <div className="trustbar">
      <div className="shell">
        <div className="trust-item">
          <span className="n">25+</span>
          <span className="t">years in the UAE</span>
        </div>
        <div className="trust-item">
          <span className="n">4,000+</span>
          <span className="t">engagements delivered</span>
        </div>
        <div className="trust-item">
          <span className="n">500+</span>
          <span className="t">businesses served</span>
        </div>
        <div className="trust-item">
          <span className="n">98%</span>
          <span className="t">of clients stay with us</span>
        </div>
        <div className="trust-item">
          <span className="n">4.9</span>
          <span className="t">Google rating</span>
        </div>
      </div>
    </div>
  );
};

export default TrustBar;
